import {Forecast} from './forecast';

export class ForecastCollection {
    private totalItems: number = 0;
    private forecasts: Forecast[] = [];

    setTotalItems(totalItems: number) {
        this.totalItems = totalItems;
    }

    setForecasts(forecasts: Forecast[]) {
        this.forecasts = forecasts;
    }

    getTotalItems(): number {
        return this.totalItems;
    }

    getForecasts(): Forecast[] {
        return this.forecasts;
    }
}
